import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "MacOS filesystem's annoying little quirk",
  "description": "",
  "published": "2016-08-23T00:00:00.000Z",
  "redirect_from": ["/blog/macos-filesystems-annoying-little-quirk/swizec/6963"],
  "categories": "Opinions, Personal, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The filesystem on your shiny expensive laptop is case insensitive. Did you know?`}</p>
    <p>{`I know, but I always forget. Your code looks like it works. It compiles, the tests all pass, you can run it, and you can play with it. Then you push to production, and it breaks. Sometimes in the build step, sometimes as late as runtime, but inevitably, it breaks.`}</p>
    <p>{`This is the one situation where I envy all my friends who work on Linux, maybe even Windows. They've never had to deal with this shit.`}</p>
    <p>{`MacOS → case insensitive. Linux → case sensitive.`}</p>
    <p>{`You thought working with JavaScript would get you away from these low level concerns, didn't you? Yeah, me too.`}</p>
    <p>{`Here's why you should care. Watch this gif:`}</p>
    <p><img parentName="p" {...{
        "src": "/1cb509d52ba3b0cfc7a78c497612c9a8/iQpaLXA.gif",
        "alt": null
      }}></img></p>
    <p>{`Make a file called `}<inlineCode parentName="p">{`ALLCAPS.js`}</inlineCode>{`, read it as `}<inlineCode parentName="p">{`allcaps.js`}</inlineCode>{`, and MacOS doesn't even bat an eye. Then you put the same code on a Linux server, and all hell breaks loose.`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`This quirk shows up when you least expect it – innocent camelCAse typos. Your code works, `}<inlineCode parentName="p">{`git status`}</inlineCode>{` says everything's merged, and the typo goes unnoticed until it's too late.`}</p>
    <p>{`I'm too embarrassed to say how much time I've lost to this quirk over the years. So I won't.`}</p>
    <p>{`Here's to hoping I'll stop forgetting now. ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      